<!-- code 1 -->
function openCity(evt, cityName) {
  var tabcontent, tablinks;
  tabcontent = $(".tabcontent");
  tabcontent.hide();
  tablinks = $(".tablinks");
  tablinks.removeClass("active");
  $("#" + cityName).show();
  $(evt.currentTarget).addClass("active");
}

<!-- code 2 mobile accordions NC -->
 document.addEventListener("DOMContentLoaded", function(event) { 


var acc = document.getElementsByClassName("accordion");
var panel = document.getElementsByClassName('panel');

for (var i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        var setClasses = !this.classList.contains('active');
        setClass(acc, 'active', 'remove');
        setClass(panel, 'show', 'remove');

        if (setClasses) {
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("show");
//           $(".panel.show").animate({ scrollTop: 0 }, "slow");
        }
//                   this.nextElementSibling.classList.contains("show").scrollTop = 0;

    }
}

function setClass(els, className, fnName) {
    for (var i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
    }
}

});

 /* scroll to its active panel */
  



$(document).ready(function() {
  $("body").on("click", '.more-about-product .Button--secondary', function() {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });
  
});



$(document).ready(function(){

  $(".modal-link-a.ingredient-link").click(function(){
    $("body").addClass("ingredient-active");
    return false;
  });
  $("#ingredient-modal-sec .close-btn").click(function(){
    jQuery("body").removeClass("ingredient-active");
  });
  $(".modal-link-a.none-link").click(function(){
    jQuery("body").addClass("none-active");
    return false;
  });
  $("#non-modal-sec .close-btn").click(function(){
    $("body").removeClass("none-active");
  });
    $(".modal-link-a.disclaimer").click(function(){
    $("body").addClass("disclaimer-active");
    return false;
  });
  $("#disclaimer-modal-sec .close-btn").click(function(){
    $("body").removeClass("disclaimer-active");
  });
  $(".modal-link-a.covid-note").click(function(){
    $("body").addClass("covid-active");
    return false;
  });
  $("#covid-note .close-btn").click(function(){
    $("body").removeClass("covid-active");
  });
  
});


// fancy lightbox for pdp links

document.getElementById("triggger-clone").addEventListener("click", () => {
        Fancybox.show([{ src: "#ingredient-modal-sec", type: "clone" }]);
      });  


